"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFields = void 0;
var FormFields;
(function (FormFields) {
    FormFields["file"] = "file";
})(FormFields = exports.FormFields || (exports.FormFields = {}));
